import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { GALLERY } from "../../data/site";

export default function Gallery() {
  return (
    <section id="projetos" data-testid="gallery-section" className="relative py-28 sm:py-36 bg-surface/30 border-y border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-coral">
            / Nossos resultados
          </span>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Projetos com<br />relatório fotográfico.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden ${i === 0 ? "lg:col-span-2 lg:row-span-1" : ""}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <motion.img
                  src={g.url}
                  alt={g.title}
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-coral">{g.cat}</span>
                  <h3 className="font-display font-bold text-white text-xl mt-1">{g.title}</h3>
                </div>
                <span className="absolute top-4 right-4 w-3 h-3 border-t border-r border-coral opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute top-4 left-4 w-3 h-3 border-t border-l border-coral opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
